function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import CsvCatalogItem from "../../../../lib/Models/Catalog/CatalogItems/CsvCatalogItem";
import TerriaFeature from "../../../../lib/Models/Feature/Feature";
import StubCatalogItem from "../../../../lib/Models/Catalog/CatalogItems/StubCatalogItem";
import Terria from "../../../../lib/Models/Terria";
import CsvChartCustomComponent from "../../../../lib/ReactViews/Custom/CsvChartCustomComponent";
describe("CsvChartCustomComponent", function () {
  let terria;
  beforeEach(function () {
    terria = new Terria({
      baseUrl: "./"
    });
  });
  describe("setTraitsFromAttrs", function () {
    let component;
    let context;
    let node;
    beforeEach(function () {
      component = new CsvChartCustomComponent();
      context = {
        terria: terria,
        catalogItem: new StubCatalogItem(undefined, terria, undefined),
        feature: new TerriaFeature({})
      };
      node = {
        name: component.name,
        attribs: {
          data: '[["x","y","z"],[1,10,3],[2,15,9],[3,8,12],[5,25,4]]'
        }
      };
    });
    it("accepts a list of plain strings columnTitles", async function () {
      node.attribs = _objectSpread(_objectSpread({}, node.attribs), {}, {
        "column-titles": "Meteor,Speed,Temperature"
      });
      const chart = component.processNode(context, node, [], 0);
      expect(chart).toBeDefined();
      if (chart) {
        const csvCatalogItem = await chart.props.children[0].props.sourceItems[0];
        expect(csvCatalogItem instanceof CsvCatalogItem).toBeTruthy();
        expect(csvCatalogItem.columnTitles).toEqual(["Meteor", "Speed", "Temperature"]);
      }
    });
    it("accepts a list of {name, title} columnTitles", async function () {
      node.attribs = _objectSpread(_objectSpread({}, node.attribs), {}, {
        "column-titles": "x:Meteor,y:Speed,z:Temperature"
      });
      const chart = component.processNode(context, node, [], 0);
      expect(chart).toBeDefined();
      if (chart) {
        const csvCatalogItem = await chart.props.children[0].props.sourceItems[0];
        expect(csvCatalogItem instanceof CsvCatalogItem).toBeTruthy();
        expect(csvCatalogItem.columns[0].title).toBe("Meteor");
        expect(csvCatalogItem.columns[1].title).toBe("Speed");
        expect(csvCatalogItem.columns[2].title).toBe("Temperature");
      }
    });
    it("can create a download url from csv text passed as chart body", function () {
      const url = component.constructDownloadUrlFromBody("a,b\n1,2\n3,4");
      expect(url.startsWith("blob:")).toBeTruthy();
    });
  });
});